package com.nonopn.skydome.common.app.pages.certificates

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skywatcher.design.local.LocalFontSizes
import eu.codlab.compose.widgets.TextNormal
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@OptIn(ExperimentalUuidApi::class)
@Composable
fun RenderTitle(
    modifier: Modifier = Modifier,
    project: Project
) {
    Column(
        modifier.padding(16.dp),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        TextNormal(
            text = project.name,
            fontWeight = FontWeight.Bold,
            fontSize = LocalFontSizes.current.administrators.cardUserEmail
        )

        TextNormal(
            text = "#${Uuid.random()}",
            fontSize = LocalFontSizes.current.administrators.cardUserUuid
        )
    }
}
